import { PrimeReactProvider } from 'primereact/api';

const GuardianProvider = PrimeReactProvider;

export { GuardianProvider };
